<template>
  <div class="profile-basic-details">
    <SectionThreeItemsHeader class="mb-6 mt-2">
      <template v-slot:item-center>
        <h2>Diversity</h2>
      </template>
      <template v-slot:item-right>
        <EditDiversityAction v-if="isEditable" />
      </template>
    </SectionThreeItemsHeader>
    <v-skeleton-loader
      type="list-item-three-line"
      v-if="isFetchingUserDiversityTraits"
    />
    <Permissioned v-else section="workers.edit" vertical>
      <TextWithVisibilityToggle
        label="Sex"
        :text="userData.gender"
        :permission="permissions.gender"
      />
      <TextWithVisibilityToggle
        label="Cisgendered (gender identity the same as birth sex)"
        :text="userData.cisgendered"
        :permission="permissions.cisgendered"
      />
      <TextWithVisibilityToggle
        label="Age"
        :text="userData.age"
        :permission="permissions.age"
      />
      <TextWithVisibilityToggle
        label="Sexual Orientation"
        :text="userDiversityTraits.sexualOrientation"
        :permission="permissions.sexualOrientation"
      />
      <TextWithVisibilityToggle
        label="Ethnicity"
        :text="get(userData, 'ethnicOrigin.label')"
        :permission="permissions.ethnicity"
      />
      <TextWithVisibilityToggle
        label="Religion"
        :text="userDiversityTraits.religion"
        :permission="permissions.religion"
      />
      <TextWithVisibilityToggle
        label="Marital Status"
        :text="userDiversityTraits.maritalStatus"
        :permission="permissions.maritalStatus"
      />
      <TextWithVisibilityToggle
        label="Parenting/Care Responsibilities"
        :text="userDiversityTraits.careResponsibilities"
        :permission="permissions.careResponsibilities"
      />
      <TextWithVisibilityToggle
        label="Disabilities"
        :text="userDiversityTraits.disabled"
        :permission="permissions.disabilities"
      />
    </Permissioned>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { USERS_NAMESPACE } from "@/store/modules/users";
import { FETCH_USER_DIVERSITY_TRAITS } from "@/store/modules/users/actions";
import Permissioned from "@/components/common/Permissioned";
import SectionThreeItemsHeader from "@/components/common/SectionThreeItemsHeader/SectionThreeItemsHeader";
import EditDiversityAction from "@/views/settings/components/actions/EditDiversityAction";
import TextWithVisibilityToggle from "@/components/common/BaseDetails/TextWithVisibilityToggle";
import { get } from "lodash";
import { copyState } from "@/utils/helpers";
import { PERMISSIONS } from "@/constants/workers";

const {
  mapState: mapUserState,
  mapActions: mapUserActions
} = createNamespacedHelpers(USERS_NAMESPACE);

export default {
  components: {
    TextWithVisibilityToggle,
    Permissioned,
    EditDiversityAction,
    SectionThreeItemsHeader
  },
  props: {
    userData: {
      type: Object,
      required: true
    },
    isEditable: Boolean
  },
  data() {
    return {
      permissions: PERMISSIONS.DIVERSITY
    };
  },
  created() {
    this.fetchUserDiversityTraits(this.userData.id);
  },
  computed: {
    ...mapUserState(
      copyState(["isFetchingUserDiversityTraits", "userDiversityTraits"])
    )
  },
  methods: {
    ...mapUserActions({
      fetchUserDiversityTraits: FETCH_USER_DIVERSITY_TRAITS
    }),
    get
  }
};
</script>

<style lang="scss"></style>
